export default __webpack_public_path__ + "static/media/x_button_white.c2a19068.svg";